// this class handles the opposite of <noscript>-functionality

class WithScriptsUnhideHandler {
    unhideAttr = 'data-baz-with-scripts-unhide';

    constructor() {
        this.unHide();
    }

    unHide() {
        let elements = document
            .querySelectorAll(`[${this.unhideAttr}]`);

        Array.from(elements)
            .forEach(el => el.removeAttribute(this.unhideAttr));
    }
}

export default WithScriptsUnhideHandler;
